import React, { Fragment, useEffect, useMemo, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { IEmployee } from "../../interfaces/employee.interface";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Icon } from "@iconify/react";
import { IDaySale } from "../../interfaces/daysales.interface";
import DataTable, { TableColumn } from "react-data-table-component";
import { totalCases } from "../../utils";

const BeatDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<IEmployee>();
  const [sales, setSales] = useState<IDaySale[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchDistributor();
    fetchSales();
  }, []);

  const fetchDistributor = async () => {
    try {
      const result = await getApi(ROUTES.EMPLOYEE_BY_ID + params?.empId);
      setEmployee(result?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchSales = async () => {
    try {
      const result = await getApi(
        ROUTES.GET_SALES_LIST_BY_EMPLOYEE + params?.empId,
        {
          startDate: moment().format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        }
      );
      setSales(result?.data);
    } catch (error) {
      setLoading(false);
    }
  };
  const columns: TableColumn<IDaySale>[] = useMemo(
    () => [
      {
        name: "Added At",
        selector: (row) => moment(row?.addedAt).format("DD MMM YYYY hh:mm A"),
        maxWidth: "160px",
      },
      {
        name: "Shop Name",
        selector: (row: any) => row.shop?.shopName || "-",
        width: "170px",
      },
      {
        name: "Shop Owner",
        selector: (row: any) => row.shop?.shopOwner || "-",
        width: "100px",
      },
      {
        name: "State",
        selector: (row: any) => row.shop?.shopState || "-",
        width: "130px",
      },
      {
        name: "City",
        selector: (row: any) => row.shop?.shopCity || "-",
        width: "100px",
      },
      {
        name: "Investment",
        selector: (row) => row.investment || "-",
        width: "100px",
      },
      {
        name: "Orders",
        selector: (row) => totalCases(row.products),
        maxWidth: "170px",
      },
      {
        name: "Delivery Date",
        selector: (row) => moment(row?.deliveryDate).format("DD-MM-YYYY"),
        maxWidth: "140px",
      },
    ],
    []
  );
  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <>
      <div>
        <div className="d-flex">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h4 className="ms-2">Employee</h4>
        </div>
        <section>
          <div className="table-responsive my-3">
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <th>Employee</th>
                  <td>{employee?.fullName}</td>
                  <th>Email</th>
                  <td>{employee?.email}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{employee?.phone}</td>
                  <th>Status</th>
                  <td>{employee?.approved ? "Approved" : "Pending"}</td>
                </tr>
                <tr>
                  <th>Designation</th>
                  <td>{employee?.designation}</td>
                  <th>Joint On</th>
                  <td>{moment(employee?.createdAt).format("DD MMMM YYYY")}</td>
                </tr>
                <tr></tr>
                <tr>
                  <th>App Version</th>
                  <td>{employee?.appVersion || "-"}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>
                    <div>{employee?.address?.street}</div>
                    <div>
                      {employee?.address?.city}, {employee?.address?.state},{" "}
                      {employee?.address?.pincode}
                    </div>
                  </td>
                </tr>
                {Number(employee?.reporters?.length) > 0 && (
                  <tr>
                    <th>Reporters</th>
                    <td colSpan={3} className="d-flex gap-3">
                      {employee?.reporters?.map((reporter, index) => (
                        <Link
                          key={index}
                          className="nav-link text-primary text-hover-underline"
                          to={`/reporter/${reporter}`}
                        >
                          View Reporter
                        </Link>
                      ))}
                    </td>
                  </tr>
                )}
                {Number(employee?.workingCities?.length) > 0 && (
                  <tr>
                    <th>Working Cities</th>
                    <td>
                      {employee?.workingCities?.map((ct, index) => (
                        <span
                          key={index}
                          className="px-2 border rounded me-2 fs-6"
                        >
                          {ct}
                        </span>
                      ))}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div>
            <h6>Sales</h6>
          </div>
          <DataTable
            columns={columns}
            data={sales}
            highlightOnHover
            striped
            progressPending={loading}
            progressComponent={<LoadingSpinner />}
          />
        </section>
      </div>
    </>
  );
};

export default BeatDetail;
